/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../../modules/order-details';
import { ensureAuthenticated } from '../../utilities/is-authenticated';

/**
 * GetOrderFavorites Input Action
 */
export class GetOrderFavoritesInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `GetOrderFavorites`;
    public getCacheObjectType = () => 'GetOrderFavorites';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IOrderFavorite {
    OrderNumber: string;
    Title: string;
    ExtensionProperties: any[];
}

export interface IGetOrderFavoritesData {
    '@odata.context'?: string;
    Success: boolean;
    Favorites: IOrderFavorite[];
    error?: ErrorCode;
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetOrderFavoritesInput();
};

export async function action(_: GetOrderFavoritesInput, ctx: Msdyn365.IActionContext): Promise<IGetOrderFavoritesData> {
    ensureAuthenticated(ctx);

    const response = await Msdyn365.sendRequest<IGetOrderFavoritesData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetFavoriteOrders`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { Success: false, Favorites: [], error: { errorCode: response.status, errorText: response.statusText } };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetOrderFavoritesData>>action,
    id: 'GetOrderFavorites',
    input: createInput
});
